export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER = 'SET_USER';
export const SET_LOADING = 'SET_LOADING';
export const SET_AUTH = 'SET_AUTH';
export const SET_SOCKET = 'SET_SOCKET';